import angular from 'angular';
import adminUserListComponent from './admin-user-list.component';

export default angular.module('components.app.admin.admin-user-list', [])
  .component('adminUserList', adminUserListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-list/admin-user-list.module.js